module.exports = __webpack_public_path__ + "assets/f4c2c6aeb76ffcf46f56ce7252ddcddb.svg";